const routes = {
  "/": "Home",
  "/categories": "Category",
  "/categories/category_form": "Category Form",
  "/categories/edit-category": "Edit Category",
  "/categories/category": "Category Items",

  "/users": "Users",
  "/users/user_form": "User Form",
  "/users/edit_user": "Edit User",

  "/special-offers": "Special Offers",
  "/special-offers/specialOffer_form": "Special Offers Form",
  "/special-offers/edit_specialOffer": "Edit Special Offers",

  "/blogs": "Blogs",
  "/blogs/blogs_form": "Blogs Form",
  "/blogs/edit_blogs": "Edit Blogs",

  "/popular": "Popular",
  "/popular/popular_form": "Popular Form",
  "/popular/edit_popular": "Edit Popular",

  "/properties": "Properties",
  "/properties/edit-property": "Edit Property",
  "/properties/property-details": "Property Details",
  "/properties/property-form": "Property Form",

  "/gallery": "Gallery",
  "/gallery/cover_banner_form": "Gallery Form",
  "/gallery/edit_coverBanner": "Edit Gallery",

  "/banner": "Banners",
  "/banner/banner_form": "Banner Form",
  "/banner/edit_banner": "Edit Banner",

  "/orders": "Orders",
  "/orders/order_form": "Orders Form",
  "/orders/edit_order": "Edit Orders",
  "/orders/order": "Orders Items",

  "/notifications": "Notifications",
  "/notifications/notifications_form": "Notifications Form",
  "/notifications/edit_notifications": "Edit Notifications",
  // "/orders/order": "Orders Items",

  "/items": "Items",
  "/items/edit_item": "Edit Items",
  "/items/items_form": "Items Form",

  "/extras": "Extras",
  "/extras/edit_extra": "Edit Extras",
  "/extras/extras_form": "Extras Form",

  "/brands": "Brands",
  "/brands/edit_brand": "Edit Brand",
  "/brands/brand_form": "Brands Form",

  "/videos": "Videos",
  "/videos/edit_video": "Edit Video",
  "/videos/video_form": "Video Form",
};
export default routes;



// WEBPACK FOOTER //
// ./src/static/_routes.js